import find from "lodash/find";
import capitalize from "lodash/capitalize";
import placeTypes from "./placeTypes";

const _ = {
  find,
  capitalize,
};

/**
 * Uses the placeTypes to generate several isPlaceType functions.
 * @example
 *
 * isCountry(place);
 * isContinent(place);
 * isRegion(place);
 */
const placeTypeUtils = Object.keys(placeTypes).reduce((m, pt) => {
  const memo = m;
  const key = `${_.capitalize(pt)}`;

  memo[`is${key}`] = (p) => p.placeType === placeTypes[pt];

  return memo;
}, {});

export default placeTypeUtils;


// WEBPACK FOOTER //
// ../server/lib/open-planet/placeTypeUtils.js